/* ============================================================
   Atelier cart PAGE - controller
   Mirrors the cart-drawer engine (optimistic qty/remove via the Section
   Rendering API, the suburb/postcode live shipping estimate, in-cart
   discount codes, note save) for the full-page cart (sections/atelier-main-cart).
   Also drives the finish-check panel (review->scroll/pulse, dismiss).
   ============================================================ */
(function () {
  var SECTION = 'atelier-main-cart';
  var root = document.querySelector('[data-acp]');
  if (!root) return;

  var pending = {}, flushing = false, flushTimer = null, inflight = 0;
  /* quantity engine state - see "quantity engine" below */
  var epoch = 0, sending = null, flushQueued = false, writing = 0, writeTail = Promise.resolve();
  var lines = {}, ident = {};
  var retryTimer = null, retries = 0, refusals = 0, forcePreflight = false, lastSaveOk = true;
  var RETRY_MS = [700, 1500, 3000, 5000, 8000];
  /* price engine state - see "price engine" below */
  var tierTrust = null, tierAwait = false, tierTimer = null, tierMomentAt = 0, lastWriteAt = 0, discGoing = false, lastHtml = null;
  /* delivery estimate state - see "shipping estimate" below */
  var shipSeq = 0, shipLoc = null, shipSig = null, rqTimer = null;

  /* ---------- helpers ---------- */
  function rootUrl() { return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/'; }
  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function q(sel) { return root.querySelector(sel); }
  function cartFetch(url, opts, tries) {
    tries = (tries == null) ? 3 : tries;
    return fetch(url, opts).then(function (r) {
      if (r.status === 429 && tries > 0) { return new Promise(function (res) { setTimeout(res, 700); }).then(function () { return cartFetch(url, opts, tries - 1); }); }
      return r;
    });
  }
  function formatMoney(cents) {
    var fmt = (window.atelierMoneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    function fmtNum(c, precision, thousands, decimal) {
      if (isNaN(c)) c = 0;
      thousands = thousands == null ? ',' : thousands; decimal = decimal == null ? '.' : decimal; precision = precision == null ? 2 : precision;
      var n = (c / 100).toFixed(precision), parts = n.split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    var pat = /\{\{\s*(\w+)\s*\}\}/, m = fmt.match(pat); if (!m) return fmt;
    var v;
    switch (m[1]) {
      case 'amount_no_decimals': v = fmtNum(cents, 0); break;
      case 'amount_with_comma_separator': v = fmtNum(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmtNum(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = fmtNum(cents, 2, ' ', '.'); break;
      case 'amount_with_apostrophe_separator': v = fmtNum(cents, 2, "'", '.'); break;
      default: v = fmtNum(cents, 2);
    }
    return fmt.replace(pat, v);
  }
  function syncBadge(count) {
    if (count == null) return;
    document.querySelectorAll('.fkcart-shortcode-count, .fkcart-item-count').forEach(function (el) { el.textContent = count; el.setAttribute('data-item-count', count); });
  }

  /* ---------- optimistic recompute ---------- */
  /* prevLbl: the tier label before this change (applySection passes the one
     shown before its redraw) - see tierMoment() */
  function recompute(prevLbl) {
    if (prevLbl === undefined) prevLbl = tierLbl();
    var sub = 0, originalSub = 0, referenceSub = 0, count = 0;
    root.querySelectorAll('.cp-item').forEach(function (it) {
      var qn = parseInt(it.getAttribute('data-qty'), 10) || 0;
      var u = +it.getAttribute('data-unit-price') || 0, c = +it.getAttribute('data-unit-compare') || 0;
      var original = it.hasAttribute('data-unit-original-price') ? (+it.getAttribute('data-unit-original-price') || 0) : u;
      sub += u * qn; count += qn;
      originalSub += original * qn;
      referenceSub += Math.max(c, original) * qn;
    });
    /* the tier this cart earns, exactly as Shopify will charge it - only while
       CornerCart's tiers have matched Shopify's prices on this page */
    var p = pic();
    if (tierPredicts(p)) setTier(earned(tierModel(), sub), sub);
    /* order-level portion of applied discounts (code row + automatic-sale row
       + CornerCart tier milestone row, all server-rendered); line-level
       allocations are already inside data-unit-price */
    var disc = 0;
    root.querySelectorAll('[data-acp-disc-row],[data-acp-auto-row],[data-acp-tier-row]').forEach(function (r) { disc += +r.getAttribute('data-disc') || 0; });
    disc = Math.min(disc, sub);
    var st = q('[data-acp-subtotal]'); if (st) st.textContent = formatMoney(originalSub);
    var tot = q('[data-acp-total]'); if (tot) tot.textContent = formatMoney(sub - disc);
    /* grand savings line = markdown savings + discounts (approximation until
       the server re-render lands with exact allocations). Visible only while
       MARKDOWN savings exist - mirrors the Liquid md_saved gate, so the row
       never merely echoes the itemized rows above it */
    var saveTotal = Math.max(0, referenceSub - (sub - disc));
    var sr = q('[data-acp-save]');
    if (sr) { if (saveTotal > 0) { sr.classList.add('on'); var b = sr.querySelector('b'); if (b) b.textContent = formatMoney(saveTotal); } else sr.classList.remove('on'); }
    var cnt = q('[data-acp-count]'); if (cnt) cnt.textContent = count + ' ' + (count === 1 ? 'item' : 'items');
    var sc = q('[data-acp-subcount]'); if (sc) sc.textContent = count + ' ' + (count === 1 ? 'item' : 'items');
    /* floor, as Liquid's divided_by does on the server render */
    var ins = q('[data-acp-instal]'); if (ins) ins.textContent = formatMoney(Math.floor((sub - disc) / 4));
    syncBadge(count);
    root.classList.toggle('is-empty', count === 0);
    markShipStale();
    paintUnsure(p);
    tierMoment(prevLbl);
  }
  /* The estimate on screen was priced for an earlier cart the moment the cart
     changes: flag it .stale on the tap ("Updating delivery") instead of after the
     save and the re-quote start (Chris 2026-10-06: the old figure sat there for
     1.5-2 s). Back to the cart it was priced for = no longer stale. */
  function markShipStale() {
    var ship = q('[data-acp-ship]');
    if (!ship || !ship.classList.contains('done') || shipSig === null) return;
    if (cartSig() !== shipSig) ship.classList.add('stale');
    else if (!ship.classList.contains('loading')) ship.classList.remove('stale');
  }
  function updateLine(it) {
    var qn = parseInt(it.querySelector('.cp-qty .n').textContent, 10) || 0;
    var u = it.hasAttribute('data-unit-original-price') ? (+it.getAttribute('data-unit-original-price') || 0) : (+it.getAttribute('data-unit-price') || 0);
    var c = +it.getAttribute('data-unit-compare') || 0;
    var now = it.querySelector('.cp-pr .now'); if (now) now.textContent = formatMoney(u * qn);
    var was = it.querySelector('.cp-pr .was'); if (was && c > u) was.textContent = formatMoney(c * qn);
    var ea = it.querySelector('.cp-pr .ea'); if (ea) ea.style.display = qn > 1 ? '' : 'none';
  }

  /* ---------- server sync (Section Rendering API) ---------- */
  /* every server render: the truth for the whole cart, then the edits it does
     not include yet are laid back over it (see "quantity engine" below), and
     the tier CornerCart is still catching up on (see "price engine") */
  function applySection(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-acp]'); if (!fresh) return;
    lastHtml = html;
    lines = readLines(fresh);
    remap(lines);
    var prevLbl = tierLbl();
    swapIn(fresh);
    judgeTier();   // Shopify's own picture, before our edits go back over it
    if (overlayEdits() || tierAwait || discGoing) recompute(prevLbl);
    else { paintUnsure(); tierMoment(prevLbl); }
  }
  function swapIn(fresh) {
    var keep = discState(q('[data-acp-disc-input]'), q('[data-acp-disc-msg]'));
    ['[data-acp-items]', '[data-acp-checks]', '[data-acp-disc]', '[data-acp-disc-body]'].forEach(function (sel) {
      var f = fresh.querySelector(sel), c = q(sel);
      if (f && c && f.innerHTML !== c.innerHTML) c.innerHTML = f.innerHTML;
    });
    restoreDisc(keep, q('[data-acp-disc-input]'), q('[data-acp-disc-msg]'));
    ['[data-acp-count]', '[data-acp-subcount]', '[data-acp-subtotal]', '[data-acp-total]', '[data-acp-instal]', '[data-acp-disc-lbl]'].forEach(function (sel) {
      var f = fresh.querySelector(sel), c = q(sel);
      if (f && c) c.textContent = f.textContent;
    });
    var fs = fresh.querySelector('[data-acp-save]'), cs = q('[data-acp-save]');
    if (fs && cs) { cs.className = fs.className; cs.innerHTML = fs.innerHTML; }
    root.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
  }
  /* The discount panel is redrawn with the rest of the page, so a background
     redraw used to wipe a code the customer was still typing (and the "isn't
     valid" message). Carry both across; only an EMPTY fresh field or message is
     filled, so a redraw that means to change them (code applied) still wins. */
  function discState(input, msg) {
    return {
      input: input, typed: input ? input.value : '', focused: !!input && document.activeElement === input,
      caret: input && document.activeElement === input ? input.selectionStart : null,
      msg: msg, text: msg ? msg.textContent : '', cls: msg ? msg.className : ''
    };
  }
  function restoreDisc(k, input, msg) {
    if (input && input !== k.input && k.typed && !input.value) {
      input.value = k.typed;
      if (k.focused) { input.focus(); try { input.setSelectionRange(k.caret, k.caret); } catch (e) { /* not a text field */ } }
    }
    if (msg && msg !== k.msg && k.text && !msg.textContent) { msg.textContent = k.text; msg.className = k.cls; }
  }

  /* force: show Shopify's cart even while a save is pending (only after a save
     has been given up) - a newer edit still wins over it.
     Resolves true when the picture was shown. */
  function refresh(force) {
    var start = epoch;
    inflight++;
    return cartFetch(rootUrl() + '?section_id=' + SECTION)
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return false;
        /* a picture taken before the latest edit or save is old news: dropping it is
           what stops a background check putting back a number the customer changed */
        if (start !== epoch || (force !== true && busy())) return false;
        applySection(html);
        return true;
      })
      .catch(function (e) { console.error('[atelier-cart-page] refresh', e); return false; })
      .finally(function () { inflight--; });
  }
  /* CornerCart applies/updates its tier offer AFTER our mutation round-trip
     (its engine sees our /cart call land, then writes its own cart attribute,
     then the discount function reprices) - so a post-mutation render is one
     beat behind on tier crossings. Settle checks = two paced re-fetches after
     each mutation settles (mirrors the drawer); gated on an active goal
     campaign (or a rendered row that may need retiring) so carts run zero
     extra requests while no tiers are configured. */
  function tierActive() {
    try {
      var arr = window.corner && window.corner.campaigns;
      if (arr && arr.length) {
        for (var i = 0; i < arr.length; i++) {
          var c = arr[i];
          if (c && c.type === 'goal_meter_in_cart' && c.status === 'active') return true;
        }
      }
    } catch (e) { /* ignore */ }
    return !!root.querySelector('[data-acp-tier-row]');
  }
  var settleTimers = [];
  function scheduleSettle() {
    if (!tierActive()) return;
    settleTimers.forEach(clearTimeout);
    settleTimers = [];
    [1000, 2200, 3600].forEach(function (ms) {
      settleTimers.push(setTimeout(function () {
        if (busy()) return;  // mid-edit: the next save reschedules
        refresh();
      }, ms));
    });
  }
  /* ---------- quantity engine ----------
     The drawer's engine (assets/atelier-cart.js, "quantity engine" - the full
     why and the measurements are there), for the full-page cart. Chris,
     2026-10-02: once a customer changes a quantity or removes an item the page
     keeps their choice, and Shopify ends up with exactly what they chose.
     Every cart write runs one at a time (serial); unsaved edits are laid over
     every render (overlayEdits); reads that started before the latest edit or
     save are dropped (refresh); keys are re-resolved before sending (a removed
     line's key would sink the whole batch); passing failures are retried with
     the customer's numbers kept, real refusals show Shopify's cart with a
     message; checkout waits for a save still on its way (leaveWhenSaved).
     The save now asks for the section render in the same request (it used to
     send the save, then fetch the render separately). */
  var MSG_CHANGED = 'An item in your cart changed while you were editing - please check your cart.';
  var MSG_ADJUSTED = 'Some quantities changed when your cart was saved - please check them.';
  var MSG_FAILED = 'We couldn\'t save your last change, so your cart is shown as it is saved. Please try again.';
  var lostEdit = false, notifyTimer = null, leaving = null;

  function noop() {}
  function hasPending() { for (var k in pending) return true; return false; }
  function busy() { return flushing || flushQueued || writing > 0 || !!retryTimer || hasPending(); }
  /* run cart writes one at a time, in the order they were asked for */
  function serial(task) {
    writing++; epoch++;
    var run = writeTail.then(function () { return task(); });
    writeTail = run.then(noop, noop);
    return run.then(function (v) { writing--; epoch++; lastWriteAt = Date.now(); return v; },
      function (e) { writing--; epoch++; lastWriteAt = Date.now(); throw e; });
  }
  function vOf(key) { return String(key).split(':')[0]; }
  function readLines(scope) {
    var pic = {};
    scope.querySelectorAll('.cp-item').forEach(function (li) { var k = li.getAttribute('data-key'); if (k) pic[k] = vOf(k); });
    return pic;
  }
  /* cart JSON -> server picture; also records each line's identity (variant +
     properties), which survives the key changing */
  function noteCart(cart) {
    if (!cart || !cart.items) return null;
    var pic = {};
    cart.items.forEach(function (it) {
      pic[it.key] = String(it.variant_id);
      ident[it.key] = it.variant_id + '|' + JSON.stringify(it.properties || {});
    });
    return pic;
  }
  /* the key an edit should go out with: its own while the line still has it,
     else the one line with the same identity, else the one line of that variant;
     null when the line has left the cart or cannot be told apart */
  function liveKey(key, pic) {
    if (pic[key]) return key;
    var v = vOf(key), id = ident[key], byId = [], byV = [];
    for (var k in pic) {
      if (pic[k] !== v) continue;
      byV.push(k);
      if (id && ident[k] === id) byId.push(k);
    }
    if (byId.length === 1) return byId[0];
    if (byV.length === 1 && (!id || !ident[byV[0]] || ident[byV[0]] === id)) return byV[0];
    return null;
  }
  function remap(pic) {
    [pending, sending].forEach(function (map) {
      if (!map) return;
      Object.keys(map).forEach(function (k) {
        if (pic[k]) return;
        var qn = map[k], nk = liveKey(k, pic);
        delete map[k];
        if (nk) { if (!(nk in map)) map[nk] = qn; }
        else if (qn > 0) lostEdit = true;   // its line has left the cart: nothing to apply it to (a removal is simply done)
      });
    });
  }
  /* lay the edits Shopify has not confirmed yet over the page */
  function overlayEdits() {
    var edits = {}, any = false, k;
    if (sending) for (k in sending) { edits[k] = sending[k]; any = true; }
    for (k in pending) { edits[k] = pending[k]; any = true; }
    if (!any) return false;
    root.querySelectorAll('.cp-item').forEach(function (li) {
      var key = li.getAttribute('data-key');
      if (!key || !(key in edits)) return;
      var qn = edits[key];
      if (qn <= 0) { li.remove(); return; }
      var n = li.querySelector('.cp-qty .n');
      if (!n) return;
      li.setAttribute('data-qty', qn);
      n.textContent = qn;
      updateLine(li);
    });
    if (lostEdit) { lostEdit = false; notify(MSG_CHANGED); }
    return true;
  }
  function notify(text) {
    var sum = q('[data-acp-summary]');
    if (!sum) return;
    var el = sum.querySelector('.cp-sync-msg');
    if (!el) {
      el = document.createElement('p');
      el.className = 'cp-disc-msg err cp-sync-msg';
      el.setAttribute('role', 'status');
      el.style.margin = '0 0 10px';
      var h = sum.querySelector('.cp-sum-h');
      if (h) h.insertAdjacentElement('afterend', el); else sum.insertBefore(el, sum.firstChild);
    }
    el.textContent = text;
    clearTimeout(notifyTimer);
    notifyTimer = setTimeout(function () { el.textContent = ''; }, 9000);
  }

  function queue(key, qty) { pending[key] = qty; epoch++; clearTimeout(flushTimer); flushTimer = setTimeout(flush, 450); }
  function flush() {
    clearTimeout(flushTimer); flushTimer = null;
    if (!hasPending() || flushQueued) return;
    flushQueued = true;
    serial(sendPending).catch(function (e) { console.error('[atelier-cart-page] save', e); });
  }
  function readCart() {
    return fetch(rootUrl() + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  /* re-read the cart before sending when a key could be ambiguous */
  function needsPreflight() {
    var count = {}, k;
    for (k in lines) count[lines[k]] = (count[lines[k]] || 0) + 1;
    for (k in pending) if (!lines[k] || count[vOf(k)] > 1) return true;
    return false;
  }
  function postUpdates(updates) {
    return fetch(rootUrl() + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: SECTION, sections_url: location.pathname })
    }).then(function (r) {
      /* judged by the body, not the Content-Type (Shopify's .js endpoints are not
         labelled json): a reply that is not JSON - a bot-check page, a proxy error -
         is a passing failure, even with a 200 */
      return r.text().then(function (t) {
        var j = null;
        try { j = JSON.parse(t); } catch (err) { /* not JSON */ }
        if (!j) return { ok: false, status: r.ok ? 0 : (r.status || 0) };
        return { ok: r.ok, status: r.status, data: j };
      }, function () { return { ok: false, status: 0 }; });
    }, function () { return { ok: false, status: 0 }; });
  }
  function sendPending() {
    flushQueued = false;
    if (!hasPending()) return Promise.resolve();
    var pre = (forcePreflight || needsPreflight()) ? readCart() : Promise.resolve(null);
    return pre.then(function (cart) {
      forcePreflight = false;
      var pic = noteCart(cart);
      if (pic) lines = pic;
      remap(lines);
      if (lostEdit) { lostEdit = false; notify(MSG_CHANGED); }
      if (!hasPending()) return;   // nothing left to send (a removal that has already landed)
      var sent = sending = pending;
      pending = {};
      flushing = true;
      return postUpdates(sent).then(function (res) {
        flushing = false;
        if (!res.ok || !res.data) { failed(sent, res); return; }
        sending = null; retries = 0; refusals = 0; lastSaveOk = true;
        var data = res.data, html = data.sections && data.sections[SECTION];
        var pic2 = noteCart(data);   // identities first, so edits made meanwhile follow a changed key
        if (html) applySection(html);
        else { if (pic2) { lines = pic2; remap(lines); } setTimeout(function () { refresh(); }, 0); }
        checkAdjusted(sent, data);
        if (!hasPending()) syncBadge(data.item_count);
        requote();
        scheduleSettle();
      });
    }).catch(function (e) {
      flushing = false;
      console.error('[atelier-cart-page] save', e);
      if (sending) failed(sending, { ok: false, status: 0 });
    });
  }
  /* a save did not land: keep the customer's numbers (newer edits win) and retry,
     or - for a real refusal that survives a fresh read of the cart - give up */
  function failed(sent, res) {
    sending = null;
    var merged = {}, k;
    for (k in sent) merged[k] = sent[k];
    for (k in pending) merged[k] = pending[k];
    pending = merged;
    console.warn('[atelier-cart-page] save not applied', res.status, res.data && (res.data.description || res.data.message));
    if (res.status === 400 || res.status === 404 || res.status === 422) {
      if (++refusals <= 1) { forcePreflight = true; flush(); return; }   // usually a key that changed: re-read, resend once
      giveUp();
      return;
    }
    if (retries >= RETRY_MS.length) { giveUp(); return; }
    clearTimeout(retryTimer);
    retryTimer = setTimeout(function () { retryTimer = null; flush(); }, RETRY_MS[retries++]);
  }
  function giveUp() {
    clearTimeout(retryTimer); retryTimer = null;
    pending = {}; sending = null; retries = 0; refusals = 0; lastSaveOk = false;
    notify(MSG_FAILED);
    requote();
    setTimeout(function () { refresh(true); }, 0);   // Shopify's cart, as it really is
  }
  /* Shopify answered with a different quantity than we sent and the customer has
     not edited that line since - its render (already shown) is the truth; say so.
     Exact key or a unique identity only: a guess must never raise a false alarm. */
  function checkAdjusted(sent, cart) {
    var pic = noteCart(cart);
    if (!pic) return;
    var qty = {};
    cart.items.forEach(function (it) { qty[it.key] = it.quantity; });
    for (var k in sent) {
      var nk = pic[k] ? k : null;
      if (!nk && ident[k]) {
        var m = Object.keys(pic).filter(function (x) { return ident[x] === ident[k]; });
        if (m.length === 1) nk = m[0];
      }
      if (!nk || (nk in pending) || (k in pending)) continue;   // gone (a removal landed), unknown, or edited again since
      if (qty[nk] !== sent[k]) { notify(MSG_ADJUSTED); return; }
    }
  }
  /* resolves once every edit has reached Shopify and the tier has settled (true),
     or false when a save was given up or this takes longer than `ms`. The tier
     gets 4 s: CornerCart writes its tier from this page, so leaving first can
     send checkout out with the old one. */
  function settled(since) { return !busy() && !discGoing && (!tierAwait || Date.now() - since > 4000); }
  function whenIdle(ms) {
    flush();
    var t0 = Date.now();
    return new Promise(function (resolve) {
      (function check() {
        if (settled(t0)) { resolve(lastSaveOk); return; }
        if (Date.now() - t0 > ms) { resolve(false); return; }
        setTimeout(check, 50);
      })();
    });
  }
  /* checkout while an edit has not reached Shopify yet: hold the click, let the
     save land, then go. Nothing waiting = returns false and the link works as it
     always has. */
  function leaveWhenSaved(e, el, href) {
    if (settled(Date.now())) return false;
    if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { flush(); return false; }   // new tab/window: send now, let it open
    e.preventDefault();
    if (leaving) return true;
    leaving = el;
    /* .is-saving swaps the label to "Saving your cart..." in CSS (the cart V2 overlay
       rewrites the drawer button's text, so the text itself is left alone) */
    el.setAttribute('aria-busy', 'true'); el.classList.add('is-saving');
    el.style.opacity = '.85'; el.style.pointerEvents = 'none'; el.style.cursor = 'progress';
    whenIdle(15000).then(function (ok) {
      if (ok) { window.location.href = href; return; }
      resetLeaving();
      if (lastSaveOk) notify('Still saving your cart - please try again in a moment.');   // a give-up has already said why
    });
    return true;
  }
  function resetLeaving() {
    if (!leaving) return;
    leaving.removeAttribute('aria-busy'); leaving.classList.remove('is-saving');
    leaving.style.opacity = ''; leaving.style.pointerEvents = ''; leaving.style.cursor = '';
    leaving = null;
  }
  /* Back from checkout restores this page from the back/forward cache with the
     button still held - release it */
  window.addEventListener('pageshow', function (ev) { if (ev.persisted) resetLeaving(); });
  /* leaving the page any other way inside the merge window: send what is waiting
     with keepalive so it survives the page */
  window.addEventListener('pagehide', function () {
    clearTimeout(flushTimer);
    if (!hasPending()) return;
    var body = {}, any = false;
    for (var k in pending) { var nk = liveKey(k, lines); if (nk) { body[nk] = pending[k]; any = true; } }
    pending = {};
    if (!any) return;
    try {
      fetch(rootUrl() + 'cart/update.js', {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: body })
      });
    } catch (err) { /* the page is going; nothing more to do */ }
  });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden' && hasPending()) flush(); });

  /* ---------- price engine ----------
     The drawer's price engine (assets/atelier-cart.js, "price engine" - the full
     why is there), for the full-page cart. Chris, 2026-10-06: never a wrong
     price, and the right one on the click. The CornerCart tier is worked out
     here (setTier) and laid over replies CornerCart has not caught up with yet,
     only while its tiers have matched Shopify's prices on this page (judgeTier);
     figures that cannot be worked out exactly wait as placeholders (.acp-pend,
     paintUnsure); checkout waits up to 4 s for the tier to settle. */
  /* the running CornerCart goal campaign - the drawer's goalCampaign() */
  function goalCampaign() {
    try {
      var arr = window.corner && window.corner.campaigns;
      if (!arr || !arr.length) return null;
      var now = Date.now();
      for (var i = 0; i < arr.length; i++) {
        var c = arr[i];
        if (!c || c.type !== 'goal_meter_in_cart' || c.surface !== 'cart_widget') continue;
        if (c.status !== 'active') continue;
        if (c.audience && c.audience.everyone !== true) continue;
        var s = c.schedule || {};
        if (s.startsAt && now < Date.parse(s.startsAt)) continue;
        if (s.endsAt && now > Date.parse(s.endsAt)) continue;
        var d = c.details || {};
        if (d.goalType !== 'totalOrderValue') continue;
        if (!d.milestones || !d.milestones.length) continue;
        return d;
      }
    } catch (e) { /* no campaign we can read */ }
    return null;
  }
  function tierLbl() { var l = root.querySelector('[data-acp-tier-row] .lbl'); return l ? l.textContent : null; }
  /* the running tiers as [{ goal (cents), pct }], or null when they are not one
     whole-order percentage each */
  function tierModel() {
    var d = goalCampaign();
    if (!d) return null;
    var out = [];
    for (var i = 0; i < d.milestones.length; i++) {
      var mi = d.milestones[i], st = mi && mi.rewards && mi.rewards.rewardStack;
      if (!st || st.length !== 1 || st[0].unit !== 'percent' || (st[0].type && st[0].type !== 'orderDiscount')) return null;
      var pct = +st[0].value, goal = +mi.goal;
      if (!(pct > 0 && pct < 100) || !(goal >= 0)) return null;
      out.push({ goal: Math.round(goal * 100), pct: pct });
    }
    return out.sort(function (a, b) { return a.goal - b.goal; });
  }
  function earned(model, base) { var pct = 0; model.forEach(function (t) { if (base >= t.goal) pct = t.pct; }); return pct; }
  function pctOff(base, pct) { return Math.round(base * pct / 100); }
  function editMap() { var m = {}, k; if (sending) for (k in sending) m[k] = 1; for (k in pending) m[k] = 1; return m; }
  function pic() {
    var edits = editMap(), p = { base: 0, ld: false, ldEdit: false };
    root.querySelectorAll('.cp-item').forEach(function (it) {
      p.base += (+it.getAttribute('data-unit-price') || 0) * (parseInt(it.getAttribute('data-qty'), 10) || 0);
      if (it.hasAttribute('data-ldisc')) { p.ld = true; if (it.getAttribute('data-key') in edits) p.ldEdit = true; }
    });
    var row = root.querySelector('[data-acp-tier-row]');
    p.row = !!row;
    p.pct = row ? parseFloat(row.getAttribute('data-pct')) : 0;   // NaN = a tier that is not a percentage
    p.amt = row ? (+row.getAttribute('data-disc') || 0) : 0;
    p.other = !!root.querySelector('[data-acp-disc-row],[data-acp-auto-row]');
    return p;
  }
  function judgeTier() {
    var m = tierModel(), p = pic();
    if (!m || p.other || p.ld || tierTrust === false) { endAwait(); return; }
    if (p.row && isNaN(p.pct)) { stopPredicting('tier is not a percentage'); return; }
    var want = earned(m, p.base);
    if (want === p.pct) {
      if (want && pctOff(p.base, want) !== p.amt) { stopPredicting('amount ' + p.amt + ' != ' + pctOff(p.base, want)); return; }
      tierTrust = true; endAwait();
      return;
    }
    if (!tierAwait) { tierAwait = true; armTierCheck(); }   // CornerCart has not caught up yet
  }
  function tierPredicts(p) { return tierTrust === true && !discGoing && !p.other && !p.ld && !!tierModel(); }
  function stopPredicting(why) {
    tierTrust = false; endAwait();
    console.warn('[atelier-cart-page] tier prediction off for this page:', why);
  }
  function endAwait() { tierAwait = false; clearTimeout(tierTimer); tierTimer = null; }
  function armTierCheck() {
    clearTimeout(tierTimer);
    tierTimer = setTimeout(function () {
      tierTimer = null;
      if (!tierAwait) return;
      if (editsInFlight() || writing > 0 || Date.now() - lastWriteAt < 4000) { armTierCheck(); return; }
      refresh().then(function (shown) {
        if (!tierAwait) return;
        if (!shown) { armTierCheck(); return; }
        stopPredicting('tier did not settle');
        if (lastHtml) applySection(lastHtml);
      });
    }, 4500);
  }
  var TIER_CHIP = '<span class="chip"><svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg></span>';
  /* the tier row as Shopify will draw it (same markup as sections/atelier-main-cart) */
  function setTier(pct, base) {
    var row = root.querySelector('[data-acp-tier-row]');
    if (!pct) { if (row) row.remove(); return; }
    var amt = pctOff(base, pct);
    if (!row) {
      var box = q('[data-acp-disc]');
      if (!box) return;
      row = document.createElement('div');
      row.className = 'cp-tier';
      row.setAttribute('data-acp-tier-row', '');
      row.innerHTML = TIER_CHIP + '<span class="lbl"></span><b class="amt"></b>';
      box.appendChild(row);
    }
    row.setAttribute('data-pct', String(pct));
    row.setAttribute('data-disc', String(amt));
    var l = row.querySelector('.lbl'), a = row.querySelector('.amt');
    var lt = pct + '% discount unlocked', at = '\u2212' + formatMoney(amt);
    if (l.textContent !== lt) l.textContent = lt;
    if (a.textContent !== at) a.textContent = at;
  }
  /* milestone moment (mirrors the drawer): the row appeared or changed tier -
     play the settle + sheen once; a redraw mid-moment carries it on (--jo) */
  function tierMoment(prevLbl) {
    var row = root.querySelector('[data-acp-tier-row]');
    if (!row) return;
    var lbl = row.querySelector('.lbl').textContent, age = 0;
    if (prevLbl === null || lbl !== prevLbl) tierMomentAt = Date.now();
    else {
      age = Date.now() - tierMomentAt;
      if (age >= 1300 || row.classList.contains('just-on')) return;
    }
    row.style.setProperty('--jo', (-age) + 'ms');
    row.classList.add('just-on');
    setTimeout(function () { row.classList.remove('just-on'); row.style.removeProperty('--jo'); }, 1300 - age);
  }
  function editsInFlight() { return hasPending() || !!sending || flushQueued || !!retryTimer; }
  function unsure(p) {
    if (discGoing) return true;
    if (!editsInFlight() && !tierAwait) return false;
    if (p.other || p.ldEdit) return true;
    if (tierPredicts(p)) return false;
    return !!(p.row || tierModel());
  }
  function paintUnsure(p) {
    p = p || pic();
    var on = unsure(p), edits = editMap();
    root.querySelectorAll('[data-acp-total], [data-acp-disc-row] .amt, [data-acp-auto-row] .amt, [data-acp-tier-row] .amt, [data-acp-save] b, [data-acp-instal]').forEach(function (el) { el.classList.toggle('acp-pend', on); });
    var sum = q('[data-acp-summary]');
    if (sum) {
      var subv = q('[data-acp-subtotal]'); if (subv) subv.classList.toggle('acp-pend', on && p.ldEdit);
      if (on) sum.setAttribute('aria-busy', 'true'); else sum.removeAttribute('aria-busy');
    }
    root.querySelectorAll('.cp-item').forEach(function (it) {
      var now = it.querySelector('.cp-pr .now');
      if (now) now.classList.toggle('acp-pend', on && it.hasAttribute('data-ldisc') && (it.getAttribute('data-key') in edits));
    });
  }

  lines = readLines(root);   // the server-rendered page is the first server picture
  judgeTier();

  /* ---------- note ---------- */
  var saveNote = debounce(function (v) {
    serial(function () {
      return fetch(rootUrl() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) })
        .catch(function (e) { console.error('[atelier-cart-page] note', e); });
    });
  }, 450);

  /* ---------- discount code (applied IN cart) ----------
     Mirrors the drawer: POST /cart/update.js {discount: CODE} attaches the
     code server-side ('' removes; single-code UX). The re-rendered section is
     the truth for totals/applied state; discount_codes[].applicable (when the
     response carries it) also catches codes cart Liquid cannot see. */
  function setDiscMsg(text, err) {
    var m = q('[data-acp-disc-msg]');
    if (m) { m.className = 'cp-disc-msg' + (err ? ' err' : ''); m.textContent = text || ''; }
  }
  function closeTools() {
    root.querySelectorAll('.cp-tool').forEach(function (x) { x.classList.remove('on'); });
    root.querySelectorAll('.cp-panel').forEach(function (p) { p.classList.remove('on'); });
    var w = q('[data-acp-toolwrap]'); if (w) w.classList.remove('open');
  }
  function postDiscount(value) {
    return cartFetch(rootUrl() + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: value, sections: SECTION, sections_url: location.pathname })
    }).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (j) { return { ok: r.ok, data: j }; });
    });
  }
  function codeApplicable(data, code) {
    var codes = data && data.discount_codes;
    if (!codes || typeof codes.some !== 'function') return null;
    return codes.some(function (c) { return String(c.code || '').toLowerCase() === code.toLowerCase() && c.applicable !== false; });
  }
  function applyDiscount() {
    var input = q('[data-acp-disc-input]');
    var code = input ? input.value.trim() : '';
    if (!code) return;
    var btn = q('[data-acp-disc-go]'); if (btn) btn.disabled = true;
    inflight++; setDiscMsg('');
    flush();   // unsaved quantities go first, so the code is judged on the cart the customer sees
    serial(function () { return postDiscount(code); })
      .then(function (res) {
        var data = res.data;
        if (!res.ok || !data) {
          setDiscMsg((data && (data.description || data.message)) || 'Could not apply that code. Please try again.', true);
          return;
        }
        if (data.sections && data.sections[SECTION]) applySection(data.sections[SECTION]);
        requote();   // the total moved - the free-shipping rule may have flipped
        var pill = root.querySelector('[data-acp-disc-row]');
        var known = codeApplicable(data, code);
        var ok = (known === null) ? !!pill : known;
        if (ok && pill) {
          /* one-time voucher entrance + sheen (CSS .just-on) */
          pill.classList.add('just-on');
          setTimeout(function () { pill.classList.remove('just-on'); }, 1300);
          closeTools();
        } else if (ok) {
          var lbl = q('[data-acp-disc-lbl]'); if (lbl) lbl.textContent = code.toUpperCase();
          setDiscMsg('Code ' + code.toUpperCase() + ' will be applied at checkout.');
        } else {
          /* clean the stored-but-inapplicable code off FIRST; the message is
             written after the cleanup's re-render lands, or that swap wipes
             it (and the typed code) */
          serial(function () { return postDiscount(''); }).then(function (res2) {
            var d2 = res2.data;
            if (d2 && d2.sections && d2.sections[SECTION]) applySection(d2.sections[SECTION]);
          }).catch(function () { /* section already shows no discount */ })
            .then(function () {
              var inp = q('[data-acp-disc-input]');
              if (inp && !inp.value) inp.value = code;
              /* Shopify stores unknown codes as "not applicable" rather than
                 saying they don't exist, so cover both honestly */
              setDiscMsg('That code isn\'t valid or can\'t be used on this cart. Check the spelling and try again.', true);
            });
        }
      })
      .catch(function (e2) { setDiscMsg('Could not apply that code. Please try again.', true); console.error('[atelier-cart-page] discount', e2); })
      .finally(function () { var b = q('[data-acp-disc-go]'); if (b) b.disabled = false; inflight--; });
  }
  /* Taking a code off is shown on the tap (mirrors the drawer): the code's row
     goes at once and the figures it touched wait as placeholders; a failed
     removal puts the row straight back, then shows Shopify's cart. */
  function removeDiscount(refocus) {
    if (discGoing) return;
    inflight++; setDiscMsg('');
    discGoing = true;
    var row = root.querySelector('[data-acp-disc-row]'), parent = row && row.parentNode, next = row && row.nextSibling;
    if (row) row.remove();
    recompute();
    function putBack() {
      discGoing = false;
      if (row && parent && parent.isConnected && !root.querySelector('[data-acp-disc-row]')) parent.insertBefore(row, next && next.parentNode === parent ? next : null);
      recompute();
      refresh(true);
    }
    flush();
    serial(function () { return postDiscount(''); })
      .then(function (res) {
        if (!res.ok || !res.data) { putBack(); return; }
        discGoing = false;
        var html = res.data.sections && res.data.sections[SECTION];
        if (html) applySection(html); else refresh(true);
        requote();
        if (refocus) { var inp = q('[data-acp-disc-input]'); if (inp) inp.focus(); }
      })
      .catch(function (e2) { console.error('[atelier-cart-page] discount remove', e2); putBack(); })
      .finally(function () { inflight--; });
  }

  /* ---------- shipping estimate ---------- */
  var LOCS = null, locsLoading = null;
  function loadLocs() {
    if (LOCS) return Promise.resolve(LOCS);
    if (locsLoading) return locsLoading;
    locsLoading = new Promise(function (resolve) {
      if (window.atelierLocs) { LOCS = window.atelierLocs; resolve(LOCS); return; }
      var s = document.createElement('script'); s.src = window.atelierLocalitiesUrl;
      s.onload = function () { LOCS = window.atelierLocs || []; resolve(LOCS); };
      s.onerror = function () { LOCS = []; resolve(LOCS); };
      document.head.appendChild(s);
    });
    return locsLoading;
  }
  function searchLocs(s) {
    s = (s || '').trim().toLowerCase(); if (s.length < 2 || !LOCS) return [];
    var byPc = /^\d+$/.test(s), res = [];
    for (var i = 0; i < LOCS.length && res.length < 8; i++) {
      var p = LOCS[i].split('|'); var hay = byPc ? p[1] : p[0].toLowerCase();
      if (hay.indexOf(s) === 0) res.push(p);
    }
    return res;
  }
  function renderShipList(results) {
    var list = q('[data-acp-ship-list]'); if (!list) return;
    if (!results.length) { list.classList.remove('on'); list.innerHTML = ''; return; }
    list.innerHTML = results.map(function (p) {
      return '<li class="cp-ship-opt" role="option" data-s="' + esc(p[0]) + '" data-pc="' + p[1] + '" data-st="' + p[2] + '"><b>' + esc(p[0]) + '</b><span>' + p[2] + ' ' + p[1] + '</span></li>';
    }).join('');
    list.classList.add('on');
  }
  function fmtRate(p) { var n = parseFloat(p) || 0; return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)); }
  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" style="width:17px;height:17px;color:var(--atc-mute);flex:0 0 auto"><path d="M3 7h11v8H3z"/><path d="M14 10h4l3 3v2h-7z"/><circle cx="7.5" cy="17.5" r="1.6"/><circle cx="17.5" cy="17.5" r="1.6"/></svg>';
  var EDIT = '<svg class="edit" viewBox="0 0 24 24"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>';
  /* Delivery estimate follows the cart (mirrors the drawer, Chris 2026-10-06):
     once a quote is on screen, a qty change, removal or discount change
     re-prices it in place - the old figure stays readable under .stale while
     the carrier answers, instead of the estimate blanking after every edit.
     cartSig() = what the quote was priced for (same cart = no carrier call);
     shipSeq = a newer quote supersedes one still polling; requote() waits out
     the saves, so a burst of taps prices the final cart once. */
  function cartSig() {
    var s = [], disc = 0;
    root.querySelectorAll('.cp-item').forEach(function (it) { s.push(it.getAttribute('data-key') + ':' + it.getAttribute('data-qty')); });
    root.querySelectorAll('[data-acp-disc-row],[data-acp-auto-row],[data-acp-tier-row]').forEach(function (r) { disc += +r.getAttribute('data-disc') || 0; });
    return s.join('|') + '#' + disc;
  }
  function doRequote() {
    var ship = q('[data-acp-ship]');
    if (!ship || !shipLoc || root.classList.contains('is-empty')) return;
    if (!ship.classList.contains('done') && !ship.classList.contains('loading')) return;   // no quote on screen: nothing to follow
    if (ship.classList.contains('done') && shipSig === cartSig()) return;                  // already priced for this exact cart
    pickLocality(shipLoc.s, shipLoc.pc, shipLoc.st, true);
  }
  /* the Ship tool's label: the quote on screen, or the plain prompt */
  function shipLbl(t) { var l = q('[data-acp-ship-lbl]'); if (l) l.textContent = t || 'Estimate shipping'; }
  function requote() {
    clearTimeout(rqTimer);
    rqTimer = setTimeout(function () {
      if (busy() || discGoing) { requote(); return; }
      doRequote();
    }, 120);
  }
  /* Shared "deliver to" locality (PDP freight estimator + drawer use the
     same key) - enter a suburb once anywhere, remembered everywhere. */
  function saveLoc(s, pc, st) {
    try { localStorage.setItem('atelierDeliverTo', JSON.stringify({ s: s, pc: pc, st: st })); } catch (e) { /* ignore */ }
  }
  function loadLoc() {
    try {
      var v = JSON.parse(localStorage.getItem('atelierDeliverTo') || 'null');
      if (v && v.s && v.pc && v.st) return v;
    } catch (e) { /* ignore */ }
    return null;
  }
  // Retry transient responses without converting them into a delivery refusal.
  function rateRequest(url, method) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = controller && setTimeout(function () { controller.abort(); }, 10000);
    return fetch(url, { method: method || 'GET', headers: { 'Accept': 'application/json' },
      cache: 'no-store', signal: controller ? controller.signal : undefined })
      .then(function (response) {
        if (!response.ok) throw new Error('Delivery request failed: ' + response.status);
        return method === 'POST' ? null : response.json();
      }).finally(function () { if (timer) clearTimeout(timer); });
  }
  function pollRates(attempt, addr, seq, started) {
    if (seq !== shipSeq) return Promise.resolve(null);
    started = started || Date.now();
    return rateRequest(rootUrl() + 'cart/async_shipping_rates.json?' + addr)
      .then(function (data) {
        if (seq !== shipSeq) return null;
        var rates = data ? data.shipping_rates : null;
        if (rates == null) {
          if (Date.now() - started >= 15000) throw new Error('Delivery calculation is still pending');
          return new Promise(function (resolve) { setTimeout(resolve, 750); })
            .then(function () { return pollRates(attempt + 1, addr, seq, started); });
        }
        if (!Array.isArray(rates)) throw new Error('Invalid delivery response');
        return rates.filter(function (rate) {
          return rate && rate.price != null && rate.price !== '' && isFinite(Number(rate.price)) && Number(rate.price) >= 0;
        });
      });
  }
  function freshRates(addr, seq, msg, attempt, started) {
    attempt = attempt || 0;
    started = started || Date.now();
    if (seq !== shipSeq) return Promise.resolve(null);
    if (Date.now() - started > 60000) return Promise.reject(new Error('Delivery quote timed out'));
    // Let quantity and discount updates reach Shopify before asking for a quote.
    if (busy() || discGoing) {
      return new Promise(function (resolve) { setTimeout(resolve, 300); })
        .then(function () { return freshRates(addr, seq, msg, attempt, started); });
    }
    var signature = cartSig();
    return rateRequest(rootUrl() + 'cart/prepare_shipping_rates.json?' + addr, 'POST')
      .then(function () { return seq === shipSeq ? pollRates(0, addr, seq) : null; })
      .then(function (rates) {
        if (seq !== shipSeq) return null;
        if (busy() || discGoing || signature !== cartSig()) throw new Error('Cart changed during quote');
        if (!rates || !rates.length) throw new Error('Delivery quote needs a refresh');
        return rates;
      }).catch(function (error) {
        if (seq !== shipSeq) return null;
        if (attempt >= 2) throw error;
        if (msg) msg.textContent = 'Refreshing your delivery estimate...';
        return new Promise(function (resolve) { setTimeout(resolve, 1000 * (attempt + 1)); })
          .then(function () { return freshRates(addr, seq, msg, attempt + 1, started); });
      });
  }
  function showDeliveryRetry(msg) {
    if (!msg) return;
    msg.textContent = 'Your delivery estimate is taking longer than usual. ';
    var button = document.createElement('button');
    button.type = 'button';
    button.setAttribute('data-bsd-rate-retry', '');
    button.textContent = 'Refresh estimate';
    button.style.cssText = 'border:0;background:none;padding:0;font:inherit;color:inherit;text-decoration:underline;cursor:pointer';
    msg.appendChild(button);
    msg.appendChild(document.createTextNode(' or check delivery at checkout.'));
  }
  /* FREE SHIPPING promo - see snippets/atelier-freeship-rule. The rule object
     exists only while the promo is running, so both helpers are inert (and the
     extra cart.js read never happens) once it ends. */
  function fsTotalCents() {
    if (!window.BSD_FREESHIP) return Promise.resolve(null);
    return cartFetch(rootUrl() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { return c ? c.total_price : null; })
      .catch(function () { return null; });
  }
  function fsFree(pc, st, cents) {
    var FS = window.BSD_FREESHIP;
    return !!(FS && typeof cents === 'number' && FS.ok(pc, st, cents));
  }
  function pickLocality(suburb, pc, st, requoting) {
    saveLoc(suburb, pc, st);
    shipLoc = { s: suburb, pc: pc, st: st };
    var seq = ++shipSeq;
    var list = q('[data-acp-ship-list]'); if (list) { list.classList.remove('on'); list.innerHTML = ''; }
    var inp = q('[data-acp-ship-q]'); if (inp) inp.value = suburb + ', ' + st + ' ' + pc;
    var msg = q('[data-acp-ship-msg]'); if (msg) msg.textContent = '';
    /* every line is a pick-up-only item (atelier-pickup-line rows, see atelier-pickup.js):
       nothing is delivered, so no carrier call - an empty rate list would read as
       "we can't deliver to you" */
    var its = root.querySelectorAll('.cp-item'), allPickup = its.length > 0;
    for (var i = 0; i < its.length; i++) if (!its[i].querySelector('[data-apk-line]')) { allPickup = false; break; }
    var ship = q('[data-acp-ship]');
    if (allPickup) { if (msg) msg.textContent = 'Nothing in your cart needs delivery.'; if (ship) ship.classList.remove('done', 'loading', 'stale'); shipLbl(''); shipSig = null; return; }
    /* re-quote: keep the old result readable but flagged .stale (dimmed + spinner) */
    if (ship) { ship.classList.add('loading'); if (requoting && ship.classList.contains('done')) ship.classList.add('stale'); }
    var addr = 'shipping_address%5Bzip%5D=' + encodeURIComponent(pc) + '&shipping_address%5Bcountry%5D=Australia&shipping_address%5Bprovince%5D=' + encodeURIComponent(st) + '&shipping_address%5Bcity%5D=' + encodeURIComponent(suburb);
    Promise.all([freshRates(addr, seq, msg), fsTotalCents()])
      .then(function (a) { return { r: a[0], c: a[1] }; })
      .then(function (d) {
        if (seq !== shipSeq) return;   // a newer request superseded this one
        var rates = d.r || [], fsCents = d.c;
        /* no rate = no estimate: a stale figure must never pose as current */
        if (!rates.length) { showDeliveryRetry(msg); if (ship) ship.classList.remove('done'); shipLbl(''); shipSig = null; return; }
        rates.sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
        var r = rates[0];
        var free = parseFloat(r.price) === 0 || fsFree(pc, st, fsCents);
        var price = free ? 'FREE' : fmtRate(r.price);
        var resEl = q('[data-acp-ship-res]');
        if (resEl) resEl.innerHTML = TRUCK + '<span class="rtxt">' + esc(r.name) + ' to <b>' + esc(suburb) + ' ' + pc + '</b></span><span class="rprice' + (free ? ' free' : '') + '">' + price + '</span>' + EDIT;
        if (ship) ship.classList.add('done');
        shipLbl(pc + ' \u00b7 ' + price);
        shipSig = cartSig();
      })
      .catch(function (e) { if (seq !== shipSeq) return; showDeliveryRetry(msg); if (ship) ship.classList.remove('done'); shipLbl(''); shipSig = null; console.warn('[atelier-cart-page] Estimate unavailable after automatic refresh', e.message); })
      .finally(function () { if (ship && seq === shipSeq) ship.classList.remove('loading', 'stale'); });
  }

  /* ---------- finish-check panel ---------- */
  function reviewFlags() {
    var first = root.querySelector('.cp-item--flag'); if (!first) return;
    first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    root.querySelectorAll('.cp-item--flag').forEach(function (it) {
      it.classList.remove('pulse'); void it.offsetWidth; it.classList.add('pulse');
    });
  }

  /* ---------- delegated events ---------- */
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-bsd-rate-retry]')) { var retryLoc = shipLoc || loadLoc(); if (retryLoc) pickLocality(retryLoc.s, retryLoc.pc, retryLoc.st); return; }
    var inc = e.target.closest('[data-acp-plus]'), dec = e.target.closest('[data-acp-minus]'), rm = e.target.closest('[data-acp-remove]');
    if (inc || dec || rm) {
      var li = e.target.closest('.cp-item'); if (!li) return;
      if (li.classList.contains('removing')) return;   // already on its way out: a second tap must not bring it back
      var key = li.getAttribute('data-key'), qn = parseInt(li.getAttribute('data-qty'), 10) || 1;
      var nq = inc ? qn + 1 : (rm ? 0 : qn - 1);
      /* queued first, so the recompute knows this edit is on its way; a removal
         moves the totals on the tap and the row leaves after its animation */
      if (nq <= 0) { li.setAttribute('data-qty', '0'); li.classList.add('removing'); queue(key, 0); recompute(); setTimeout(function () { li.remove(); recompute(); }, 180); }
      else { li.setAttribute('data-qty', nq); var n = li.querySelector('.cp-qty .n'); if (n) n.textContent = nq; updateLine(li); queue(key, nq); recompute(); }
      return;
    }
    /* checkout with an edit still on its way: save it first (nothing waiting =
       the link works exactly as before). The pick-up-only check in
       atelier-pickup.js runs earlier (document capture) and stops this click
       when it has to. */
    var checkout = e.target.closest('[data-acp-checkout]');
    if (checkout) { leaveWhenSaved(e, checkout, checkout.href || '/checkout'); return; }
    if (e.target.closest('[data-acp-note-open]')) { var note = q('[data-acp-note]'); note.classList.add('open'); var ta = note.querySelector('textarea'); if (ta) ta.focus(); return; }
    var tool = e.target.closest('.cp-tool');
    if (tool) {
      var t = tool.getAttribute('data-tool'), isOn = tool.classList.contains('on');
      root.querySelectorAll('.cp-tool').forEach(function (x) { x.classList.toggle('on', x === tool && !isOn); });
      root.querySelectorAll('.cp-panel').forEach(function (p) { p.classList.toggle('on', p.getAttribute('data-panel') === t && !isOn); });
      q('[data-acp-toolwrap]').classList.toggle('open', !isOn);
      if (!isOn) { var input = root.querySelector('.cp-panel[data-panel="' + t + '"] input'); if (input) setTimeout(function () { input.focus(); }, 260); }
      /* Ship tool opened with a remembered locality (saved here, in the
         drawer, or on a PDP) and no rate yet -> quote it straight away. */
      if (!isOn && t === 'ship') {
        var shipEl = q('[data-acp-ship]');
        var shipQ = q('[data-acp-ship-q]');
        var savedLoc = loadLoc();
        if (savedLoc && shipEl && !shipEl.classList.contains('done') && !shipEl.classList.contains('loading') && shipQ && !shipQ.value) {
          pickLocality(savedLoc.s, savedLoc.pc, savedLoc.st);
        }
      }
      return;
    }
    var opt = e.target.closest('.cp-ship-opt');
    if (opt) { pickLocality(opt.getAttribute('data-s'), opt.getAttribute('data-pc'), opt.getAttribute('data-st')); return; }
    var res = e.target.closest('[data-acp-ship-res]');
    if (res) { var ship = q('[data-acp-ship]'); if (ship) ship.classList.remove('done'); var inp = q('[data-acp-ship-q]'); if (inp) { inp.value = ''; inp.focus(); } return; }
    if (e.target.closest('[data-acp-disc-go]')) { applyDiscount(); return; }
    /* shared by the summary-row Remove and the panel's; refocus the input
       only when removing from inside the panel */
    var discRm = e.target.closest('[data-acp-disc-rm]');
    if (discRm) { removeDiscount(!!discRm.closest('.cp-panel')); return; }
    if (e.target.closest('[data-acp-review]')) { reviewFlags(); return; }
    if (e.target.closest('[data-acp-compat-x]')) { var panel = q('[data-acp-compat]'); if (panel) panel.style.display = 'none'; root.querySelectorAll('.cp-item--flag').forEach(function (it) { it.classList.remove('cp-item--flag'); }); return; }
  });

  var debouncedSearch = debounce(function (v) { loadLocs().then(function () { renderShipList(searchLocs(v)); }); }, 120);
  root.addEventListener('input', function (e) {
    if (e.target.matches('[data-acp-ship-q]')) { debouncedSearch(e.target.value); return; }
    if (e.target.closest('[data-acp-note]') && e.target.tagName === 'TEXTAREA') { saveNote(e.target.value); }
  });
  root.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches('[data-acp-disc-input]')) { e.preventDefault(); applyDiscount(); } });
  root.addEventListener('focusin', function (e) { if (e.target.matches('[data-acp-ship-q]')) loadLocs(); });
  root.addEventListener('focusout', function (e) { if (e.target.matches('[data-acp-ship-q]')) setTimeout(function () { var l = q('[data-acp-ship-list]'); if (l) l.classList.remove('on'); }, 150); });

  /* CornerCart's sanctioned onCartEdit event (mirrors the drawer): fires as
     its engine processes cart edits, including the attribute write that
     (re)applies the tier offer - refresh right then, debounced + gated; the
     timed settle probes stay as fallback. A GET refresh is not a cart edit,
     so no loop. */
  var cornerRefresh = debounce(function () {
    if (!tierActive()) return;
    if (busy()) return;
    refresh();
  }, 250);
  (function hookCorner(tries) {
    if (window.corner && typeof window.corner.on === 'function') {
      try { window.corner.on('onCartEdit', function () { cornerRefresh(); }); }
      catch (e) { console.warn('[atelier-cart-page] corner hook', e); }
      return;
    }
    if (tries > 0) setTimeout(function () { hookCorner(tries - 1); }, 150);
  })(200);
})();


